import type { IAccount } from "@apis/accounts/types"
import { InfoIcon } from "lucide-react"
import { PlanDetails } from "@components/PlanDetails/PlanDetails"

export const serializePlanSection = (accountData: IAccount) => {
  const { plan_name, product_type_code, revenue_class_name, terms_vars } =
    accountData

  return {
    actions: [
      {
        icon: <InfoIcon size={16} />,
        ariaLabel: "Show Plan Info",
        displayedContent: <PlanDetails plan_data={accountData} />,
        displayedTitle: "Plan Details"
      },
    ],
    description_lines: [
      { content: plan_name },
      { content: terms_vars?.contract_rate_friendly },
      { content: revenue_class_name },
      { content: product_type_code },
    ],
  }
}
